import React, { useState } from 'react'

export default function CustomStepper({ Data, hoverShow = false }) {
    const [showHovered, setShowHovered] = useState(null)
    return (
        <>
            <div className='StepperOption' style={{ marginTop: '30px' }}>
                {
                    Data?.length > 0 ? Data?.map((val, id) => {
                        return (
                            <>
                                <div className='main-single-content-new'>
                                    <div className={`boxed ${showHovered == id ? "hovered" : ""}`}
                                    // onClick={()=>setShowHovered(id)}
                                        onMouseEnter={() => { hoverShow ? setShowHovered(id) : null }}
                                        onMouseLeave={() => { hoverShow ? setShowHovered(null) : null }}
                                    >
                                        <h6>{val?.value} </h6>
                                    </div>
                                    <h5>{val?.name?.split(" ").map((word, index) => (
                                        <React.Fragment key={index}>
                                            {word}
                                            {index === 0 && <br />}
                                            {index !== 0 && " "}
                                        </React.Fragment>
                                    ))}</h5>

                                    {
                                        showHovered == id ?
                                            <div className={`mouseHoverSection ${id == 0 ? "first" :  id + 1 == Data?.length ? "last" : ""}`} style={{bottom:'-60%'}}>
                                                {
                                                    Object.keys(val?.hoverData)?.length > 0 ? Object.entries(val?.hoverData)?.map(([key,pair], idx) => {
                                                        return (
                                                            <div style={{display:'flex',justifyContent:'space-between',marginTop:'5px'}}>
                                                                <h6>{key}</h6>
                                                                <h6>{pair}</h6>
                                                            </div>
                                                        )
                                                    })
                                                        : ""}
                                            </div>
                                            : ""}


                                </div>
                            </>
                        )
                    })
                        : ""}
            </div>
        </>
    )
}
